export const getPublicXToken = (
  companyId?: string,
  orgId?: string,
  userId?: string,
  roomUuid?: string
): string =>
  btoa(
    `dsr_microsite:${companyId || ''}:${orgId || ''}:${userId || ''}:${
      roomUuid || ''
    }`
  );
